
import { Cmd_none, Cmd_batch, Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ofNullable } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ensureValidToken } from "../Auth.js";
import { handleFetchError } from "../ErrorHandling.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fetch$ } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { utcNow, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { State, Msg } from "./Types.js";
import { FormState__startLoading, RequestedValue$1, FormState_get_empty } from "../Shared/Shared.js";
import { getCustomerConfiguration } from "../Requests/Configuration.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ImportHistoryEntry_$reflection } from "../Shared/Importer.js";
import { list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";

export const exportSpecificToolCmd = Cmd_OfPromise_either((tupledArg) => {
    const body_1 = tupledArg[2];
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        const tenant = ofNullable(localStorage.getItem("tenant"));
        return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
            const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                let matchValue;
                return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                    const matchValue_1 = tenant;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        return singleton(["X-ONE-Tenant", matchValue_1]);
                    }
                }))));
            })), 0)]);
            const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
            return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
        });
    }));
}, ["/api/export/tools", concat("tool_export_", toString(toLocalTime(utcNow()), "yyyyMMdd_HHmmss"), ...".xlsx"), undefined], (tupledArg_1) => (new Msg(7, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(9, [Item_2])));

export const exportSimpleToolsCmd = Cmd_OfPromise_either((tupledArg) => {
    const body_1 = tupledArg[2];
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        const tenant = ofNullable(localStorage.getItem("tenant"));
        return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
            const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                let matchValue;
                return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                    const matchValue_1 = tenant;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        return singleton(["X-ONE-Tenant", matchValue_1]);
                    }
                }))));
            })), 0)]);
            const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
            return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
        });
    }));
}, ["/api/export/tools-with-quantity", concat("tool_with_quantity_export_", toString(toLocalTime(utcNow()), "yyyyMMdd_HHmmss"), ...".xlsx"), undefined], (tupledArg_1) => (new Msg(7, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(9, [Item_2])));

export const exportConsumablesCmd = Cmd_OfPromise_either((tupledArg) => {
    const body_1 = tupledArg[2];
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        const tenant = ofNullable(localStorage.getItem("tenant"));
        return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
            const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                let matchValue;
                return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                    const matchValue_1 = tenant;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        return singleton(["X-ONE-Tenant", matchValue_1]);
                    }
                }))));
            })), 0)]);
            const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
            return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
        });
    }));
}, ["/api/export/consumables", concat("consumable_export_", toString(toLocalTime(utcNow()), "yyyyMMdd_HHmmss"), ...".xlsx"), undefined], (tupledArg_1) => (new Msg(7, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(9, [Item_2])));

export const exportSetsCmd = Cmd_OfPromise_either((tupledArg) => {
    const body_1 = tupledArg[2];
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        const tenant = ofNullable(localStorage.getItem("tenant"));
        return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
            const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                let matchValue;
                return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                    const matchValue_1 = tenant;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        return singleton(["X-ONE-Tenant", matchValue_1]);
                    }
                }))));
            })), 0)]);
            const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
            return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
        });
    }));
}, ["/api/export/sets", concat("set_export_", toString(toLocalTime(utcNow()), "yyyyMMdd_HHmmss"), ...".xlsx"), undefined], (tupledArg_1) => (new Msg(7, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(9, [Item_2])));

export function init(tokenData) {
    return [new State(FormState_get_empty(), undefined, new RequestedValue$1(0, []), tokenData), Cmd_batch(ofArray([getCustomerConfiguration((Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(9, [Item_1]))), Cmd_OfPromise_either_1((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(ImportHistoryEntry_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/import/history", (Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(9, [Item_3])))]))];
}

export function extractBlob(response, filename) {
    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response.blob().then((_arg) => (Promise.resolve([_arg, filename]))))));
}

export function getBlob(response, filename) {
    return Cmd_OfPromise_either((tupledArg) => extractBlob(tupledArg[0], tupledArg[1]), [response, filename], (tupledArg_1) => (new Msg(8, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(9, [Item_2])));
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.FormState, state.CustomerConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.TokenData), Cmd_none()];
        case 2:
            return [new State(state.FormState, msg.fields[0], state.ImportHistory, state.TokenData), Cmd_none()];
        case 3:
            return [new State(FormState__startLoading(state.FormState), state.CustomerConfiguration, state.ImportHistory, state.TokenData), exportSpecificToolCmd];
        case 4:
            return [new State(FormState__startLoading(state.FormState), state.CustomerConfiguration, state.ImportHistory, state.TokenData), exportSimpleToolsCmd];
        case 6:
            return [new State(FormState__startLoading(state.FormState), state.CustomerConfiguration, state.ImportHistory, state.TokenData), exportSetsCmd];
        case 5:
            return [new State(FormState__startLoading(state.FormState), state.CustomerConfiguration, state.ImportHistory, state.TokenData), exportConsumablesCmd];
        case 7:
            return [new State(FormState_get_empty(), state.CustomerConfiguration, state.ImportHistory, state.TokenData), getBlob(msg.fields[0], msg.fields[1])];
        case 8: {
            const url_3 = window.URL.createObjectURL(msg.fields[0]);
            const element = document.createElement("a");
            element.setAttribute("href", url_3);
            element.setAttribute("download", msg.fields[1]);
            document.body.appendChild(element);
            element.click();
            window.URL.revokeObjectURL(url_3);
            element.remove();
            return [state, Cmd_none()];
        }
        case 9:
            return [new State(FormState_get_empty(), state.CustomerConfiguration, state.ImportHistory, state.TokenData), Cmd_none()];
        default:
            return [new State(state.FormState, state.CustomerConfiguration, new RequestedValue$1(0, []), state.TokenData), Cmd_OfPromise_either_1((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(ImportHistoryEntry_$reflection())));
                }, refreshOn)))(true).then((_arg) => {
                    const result_1 = _arg;
                    return (result_1.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_1.fields[0]);
                    })())) : (Promise.resolve(result_1.fields[0]));
                });
            })), "/api/import/history", (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(9, [Item_1])))];
    }
}

